import React from "react";
import { StrapiImage } from "../Types";
import { fixStrapiUrl } from "../../helpers/strapiUrl";


interface BannerImageI {
  data: {
    DesktopImage: StrapiImage;
    DesktopImageAlt: string;
    DesktopImageURL: string;
    MobileImage: StrapiImage;
    MobileImageAlt: string;
    MobileImageURL: string;
  };
}

const BannerImage = ({ data }: BannerImageI) => {
  const {
    DesktopImage,
    DesktopImageAlt,
    DesktopImageURL,
    MobileImage,
    MobileImageAlt,
    MobileImageURL,
  } = data;

  return (
    <section className="overflow-hidden md:h-[350px] h-[216px]">
      {DesktopImage?.url ? (
        <img
          src={fixStrapiUrl(DesktopImage?.url)}
          alt={DesktopImageAlt}
          className="w-full h-full object-cover object-center md:block hidden"
          loading="lazy"
          width={1200}
          height={350}
        />
      ) : (
        <img
          src={DesktopImageURL}
          alt={DesktopImageAlt}
          className="w-full h-full object-cover object-center md:block hidden"
          loading="lazy"
          width={1200}
          height={350}
        />
      )}
      {MobileImage?.url ? (
        <img
          src={fixStrapiUrl(MobileImage?.url)}
          alt={MobileImageAlt}
          className="w-full h-full object-cover object-center md:hidden block"
          loading="lazy"
          width={768}
          height={216}
        />
      ) : (
        <img
          src={MobileImageURL}
          alt={MobileImageAlt}
          className="w-full h-full object-cover object-center md:hidden block"
          loading="lazy"
          width={768}
          height={216}
        />
      )}
    </section>
  );
};

export default BannerImage;
